import React from "react";
import * as Icons from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function Features() {
  const enabled = useSectionEnabled("features");
  const { cms } = useCMS();
  if (!enabled) return null;
  const features = cms?.features || [];

  return (
    <section id="features" className="bg-[#FFFBF6] py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-14 max-w-3xl mx-auto">
          <h2 className="lm-section-title text-2xl sm:text-4xl lg:text-5xl">
            Reliable Hosting Solutions — <span className="lm-underline-swoosh">Built for Speed</span>
          </h2>
          <p className="text-[#11151C]/65 mt-4 text-base sm:text-lg">
            Everything you need to succeed online with enterprise-grade infrastructure at affordable prices.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => {
            const Icon = Icons[f.icon] || Icons.Zap;
            return (
              <div key={f.title} className="lm-card p-6 sm:p-7">
                <span className="w-12 h-12 sm:w-14 sm:h-14 lm-icon-tile inline-flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7" />
                </span>
                <h3 className="lm-font font-bold text-[#11151C] text-lg sm:text-xl">{f.title}</h3>
                <p className="text-[#11151C]/65 mt-2 text-sm leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 overflow-hidden border-y border-[#11151C]/10 py-6">
          <div className="lm-marquee whitespace-nowrap">
            {[...Array(2)].map((_, idx) => (
              <div key={idx} className="flex items-center gap-10 sm:gap-12 pr-12">
                {features.map((f) => (
                  <span key={`${idx}-${f.title}`} className="text-[#11151C] font-bold lm-font text-lg sm:text-xl inline-flex items-center gap-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B3D]" />
                    {f.title}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
